<template>
  <app-carousel :item-gap="4" :item-width="290" :items="list">
    <template #item="{ item }">
      <div class="h-full">
        <course-card
          :course="item"
          :show-next-session="showNextSession"
          @click="onCardClick(item)"
        />
      </div>
    </template>
  </app-carousel>
</template>

<script lang="ts" setup>
import type { CourseListView } from "~/business-areas/course/composables/course-list.hook";
import {
  toAnalyticsCourseView,
  type TrackingPlanModel,
} from "~~/model/analytics.model";

const properties = defineProps<{
  list: CourseListView[];
  id: TrackingPlanModel["course_clicked"]["origin"];
  showNextSession?: boolean;
}>();

const { $analytics } = useNuxtApp();

const onCardClick = (course: CourseListView) =>
  $analytics.track("course_clicked", {
    origin: properties.id,
    course: toAnalyticsCourseView(course),
  });
</script>
